/* AA cart "you might also like" (drawer + /cart page): fetches product recommendations (section render) for the first cart line,
   injects cards into [data-aa-recs] (2-up on desktop, 1.5 peek on mobile; one-click add or inline size select).
   Also shows a free-shipping nudge (add a canvas tote) when the gap to the threshold is small.
   Re-runs after Palo Alto re-renders the drawer (MutationObserver, debounced). Adds via /cart/add.js then fires
   theme:cart:refresh (the stock drawer refresh, which also updates the header count).
   Drawer: nothing is fetched until the drawer is open (the theme renders it on every page load when the cart has items).
   Cart page: [data-aa-cart-page] root on /cart holding a [data-aa-recs] box, runs once; adding reloads the page. Totes list cached in sessionStorage for 10 min. */
(function () {
  var cache = {}, toteP = null, timer = null, busy = false, root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var PLUS = '<svg class="aa-icon" width="12" height="12" viewBox="0 0 28 28" aria-hidden="true" focusable="false"><path d="M14.3 3 C 13.8 10, 14.5 18, 13.9 25.2" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><path d="M3 14.4 C 10 13.7, 18 14.6, 25.4 13.9" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg><span>add</span>';
  function drawer() { return document.getElementById('cart-drawer') || document.querySelector('[data-aa-cart-page]'); }
  function isPage(d) { return d && d.hasAttribute('data-aa-cart-page'); }
  function isOpen(d) { return isPage(d) || d.classList.contains('is-open'); }
  function get(url) { return fetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }); }
  function cards(pid) {
    if (cache[pid]) return cache[pid];
    var base = root + 'recommendations/products?product_id=' + pid + '&limit=8&section_id=aa-cart-recs&intent=';
    cache[pid] = get(base + 'complementary').then(function (h) {
      return /data-aa-rec-list|data-aa-recs-list/.test(h) && /class="aa-rec"/.test(h) ? h : get(base + 'related');
    }).catch(function () { delete cache[pid]; return ''; });
    return cache[pid];
  }
  /* canvas totes (cached): products.json of /collections/canvas-totes, available variant only */
  function totes() {
    if (toteP) return toteP;
    var KEY = 'aa-totes-v1';
    try {
      var c = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      if (c && Date.now() - c.t < 600000 && Array.isArray(c.list)) { toteP = Promise.resolve(c.list); return toteP; }
    } catch (e) {}
    toteP = fetch(root + 'collections/canvas-totes/products.json?limit=250', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (j) {
        var out = [];
        (j.products || []).forEach(function (p) {
          if (!/-(cotton-canvas-tote-bag|canvas-tote|tote)$/.test(p.handle)) return;
          var v = (p.variants || []).filter(function (x) { return x.available; })[0];
          if (v) out.push({ handle: p.handle, id: v.id, price: parseFloat(v.price) });
        });
        try { sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), list: out })); } catch (e) {}
        return out;
      }).catch(function () { toteP = null; return []; });
    return toteP;
  }
  function pickTote(list, items) {
    if (!list.length) return null;
    var inCart = items.map(function (i) { return i.handle; });
    var pool = list.filter(function (t) { return inCart.indexOf(t.handle) < 0; });
    if (!pool.length) return null;
    for (var k = 0; k < items.length; k++) {
      var parts = items[k].handle.split('-');
      for (var n = parts.length - 1; n >= 2; n--) {
        var pre = parts.slice(0, n).join('-') + '-';
        for (var t = 0; t < pool.length; t++) if (pool[t].handle.indexOf(pre) === 0) return pool[t];
      }
    }
    return pool[0];
  }
  function money(n) { return '$' + (n % 1 ? n.toFixed(2) : String(n)); }
  function ensure(box) {
    if (!box.querySelector('.aa-recs__main')) {
      box.innerHTML = '<div class="aa-recs__tote" hidden></div><div class="aa-recs__main"></div>';
      box.removeAttribute('data-key');
    }
    return { tote: box.querySelector('.aa-recs__tote'), main: box.querySelector('.aa-recs__main') };
  }
  function renderTote(el, t, copy) {
    if (!t) { el.hidden = true; el.innerHTML = ''; el.removeAttribute('data-id'); return false; }
    if (el.getAttribute('data-id') !== String(t.id)) {
      el.innerHTML = '';
      var sp = document.createElement('span'); sp.className = 'aa-recs__tote-t'; sp.textContent = copy.replace('[price]', money(t.price));
      var b = document.createElement('button'); b.type = 'button'; b.className = 'aa-rec__add'; b.setAttribute('data-aa-rec-add', ''); b.setAttribute('data-variant-id', t.id);
      b.setAttribute('aria-label', 'add a tote to your cart'); b.innerHTML = PLUS;
      el.appendChild(sp); el.appendChild(b); el.setAttribute('data-id', t.id);
    }
    el.hidden = false; return true;
  }
  // design key: title without garment words (matches data-design in sections/aa-cart-recs.liquid)
  function designKey(t) {
    t = String(t || '').toLowerCase();
    [' kids classic tee', " women's classic tee", ' vintage heavyweight t-shirt', ' vintage heavyweight tee', ' vintage long sleeve tee', ' vintage long sleeve', ' vintage boxy tee', ' classic crewneck', ' crewneck sweatshirt', ' classic hoodie', ' hoodie', ' cotton canvas tote bag', ' canvas tote bag', ' canvas tote', ' classic tee', ' t-shirt'].forEach(function (w) { t = t.split(w).join(''); });
    return t.trim();
  }
  var TYPE_RANK = { 'T-Shirt': 0, 'Heavyweight T-Shirt': 1, 'Long Sleeve T-Shirt': 1.5, 'Sweatshirt': 2, 'Hoodie': 2.5, 'Bags': 3, 'Kids T-Shirt': 4, 'Kids clothes': 4 };
  function update() {
    var d = drawer(); if (!d || busy || !isOpen(d)) return;
    var box = d.querySelector('[data-aa-recs]'); if (!box) return;
    fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      shipState(d, c);
      if (!c.items.length) { box.hidden = true; box.removeAttribute('data-key'); return; }
      var smart = box.getAttribute('data-smart') === 'true';
      var ids = c.items.map(function (i) { return i.product_id; });
      // smart: suggestions drawn from up to 3 different products in the cart (in cart order); otherwise the first line only
      var sources = smart ? ids.filter(function (v, i) { return ids.indexOf(v) === i; }).slice(0, 3) : [ids[0]];
      var rate = (window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
      var msg = d.querySelector('[data-cart-message]');
      var limit = parseFloat((msg && msg.getAttribute('data-limit')) || box.getAttribute('data-limit')) || 0;
      var gap = limit * 100 * rate - c.total_price, maxGap = (parseFloat(box.getAttribute('data-tote-gap')) || 30) * 100 * rate;
      // "one more design" nudge: a little short of free shipping -> the suggestions become designs that each close the gap
      // nothing ships (only gift cards): no free-shipping nudges at all (audit R2-03)
      var ships = (c.items || []).some(function (i) { return i.requires_shipping; });
      if (!ships) limit = 0;
      var wantThird = box.getAttribute('data-third') === 'true' && limit > 0 && gap > 0 && gap <= (parseFloat(box.getAttribute('data-third-gap')) || 35) * 100 * rate;
      var wantTote = limit > 0 && gap > 0 && gap <= maxGap;
      var copy = box.getAttribute('data-tote-copy') || "add a tote ([price]) and shipping's free";
      var key = sources.join(',') + '|' + ids.join(',') + '|' + (wantThird ? 'n' + Math.ceil(gap / 500) : 'r');
      var recsDone = box.getAttribute('data-key') === key;
      return Promise.all([wantTote ? totes() : Promise.resolve([]), recsDone ? Promise.resolve(null) : Promise.all(sources.map(cards))]).then(function (res) {
        var parts = ensure(box);
        busy = true;
        var nudged = recsDone ? box.getAttribute('data-nudged') === '1' : false, showRecs = !recsDone ? null : !parts.main.hidden;
        if (!recsDone) {
          // parse every source's cards, interleave them (1st of each source, then 2nd...) so each cart item gets a say
          var lists = res[1].map(function (html) { var tmp = document.createElement('div'); tmp.innerHTML = html || ''; return [].slice.call(tmp.querySelectorAll('.aa-rec')); });
          var arrows = []; res[1].forEach(function (html) { if (!arrows.length) { var t2 = document.createElement('div'); t2.innerHTML = html || ''; arrows = [].slice.call(t2.querySelectorAll('.aa-recs__arrow')); } });
          var merged = [], longest = Math.max.apply(null, lists.map(function (l) { return l.length; }).concat([0]));
          for (var k = 0; k < longest; k++) lists.forEach(function (l) { if (l[k]) merged.push(l[k]); });
          var cartDesigns = c.items.map(function (i) { return designKey(i.product_title); });
          var seenP = {}, seenD = {}, list = merged.filter(function (el) {
            var pid = parseInt(el.getAttribute('data-product-id'), 10), dk = el.getAttribute('data-design') || '';
            if (ids.indexOf(pid) >= 0 || seenP[pid]) return false;
            seenP[pid] = 1;
            if (smart) { if (seenD[dk] || cartDesigns.indexOf(dk) >= 0) return false; seenD[dk] = 1; }
            return true;
          });
          if (smart) list = list.map(function (el, i) { return { el: el, i: i, r: TYPE_RANK.hasOwnProperty(el.getAttribute('data-type')) ? TYPE_RANK[el.getAttribute('data-type')] : 2 }; })
            .sort(function (x, y) { return x.r - y.r || x.i - y.i; }).map(function (x) { return x.el; });
          var heading = box.getAttribute('data-heading') || 'you might also like';
          nudged = false;
          if (wantThird) {
            var closers = list.filter(function (el) { return (parseFloat(el.getAttribute('data-price')) || 0) * rate >= gap; });
            if (closers.length) { list = closers.slice(0, 4); heading = box.getAttribute('data-third-copy') || "one more design and shipping's free"; nudged = true; }
          }
          if (!nudged) list = list.slice(0, smart ? 4 : 6);
          parts.main.innerHTML = '';
          if (list.length) {
            var h = document.createElement('p'); h.className = 'aa-recs__h' + (nudged ? ' aa-recs__h--nudge' : ''); h.textContent = heading;
            var row = document.createElement('div'); row.className = 'aa-recs__row';
            list.forEach(function (el) { row.appendChild(el); });
            parts.main.appendChild(h); parts.main.appendChild(row);
            if (list.length > 2) arrows.forEach(function (a) { parts.main.appendChild(a); });
          }
          parts.main.hidden = !list.length; showRecs = !!list.length;
          box.setAttribute('data-key', key);
          box.setAttribute('data-nudged', nudged ? '1' : '0');
        }
        // the tote nudge only when the "one more design" nudge isn't already making the free-shipping case
        var tote = wantTote && !nudged ? pickTote(res[0], c.items) : null;
        if (tote && tote.price * 100 * rate < gap) tote = null; // a tote must actually close the gap
        var showTote = renderTote(parts.tote, tote, copy);
        box.hidden = !(showTote || showRecs);
        setTimeout(function () { busy = false; }, 0);
      });
    }).catch(function () { busy = false; });
  }
  // only emailed gift cards in the cart: the email note instead of the free-shipping meter (audit R3-02)
  function shipState(d, c) {
    var digital = c.item_count > 0 && !(c.items || []).some(function (i) { return i.requires_shipping; });
    [].forEach.call(d.querySelectorAll('[data-aa-shipblock]'), function (b) { b.classList.toggle('aa-cd--digital', digital); });
  }
  var shipTimer = 0;
  function syncShip() {
    var d = drawer(); if (!d || isPage(d)) return;
    fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { shipState(d, c); }).catch(function () {});
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(update, 350); clearTimeout(shipTimer); shipTimer = setTimeout(syncShip, 120); }
  function init() {
    var d = drawer(); if (!d) return;
    var page = isPage(d);
    if (!page) {
      new MutationObserver(function () { if (!busy && isOpen(d)) schedule(); }).observe(d, { childList: true, subtree: true });
      document.addEventListener('theme:cart:loaded', schedule);
      document.addEventListener('theme:cart:added', schedule);
      document.addEventListener('theme:cart:open', schedule);
    }
    // show the chosen variant's own price (a 5XL is $35, not the $30 base; audit R2-01). No size chosen: the base price.
    function cents(c) { c = +c || 0; return '$' + (c % 100 ? (c / 100).toFixed(2) : String(c / 100)); }
    function syncPrice(card) {
      var p = card && card.querySelector('[data-aa-rec-price]'); if (!p) return;
      var sel = card.querySelector('[data-aa-rec-size]'), json = card.querySelector('[data-aa-rec-variants]');
      var price = +p.getAttribute('data-base'), cmp = +p.getAttribute('data-base-cmp');
      if (sel && sel.value && json) {
        try { var v = JSON.parse(json.textContent).filter(function (x) { return String(x[0]) === sel.value; })[0]; if (v && v.length > 5) { price = v[5]; cmp = v[6] || 0; } } catch (err) {}
      }
      p.innerHTML = (cmp > price ? '<s>' + cents(Math.floor(cmp / 100) * 100) + '</s> ' : '') + '<span>' + cents(price) + '</span>';
    }
    d.addEventListener('change', function (e) { var sel = e.target.closest && e.target.closest('[data-aa-rec-size]'); if (sel) syncPrice(sel.closest('.aa-rec')); });
    d.addEventListener('change', function (e) {
      var cs = e.target.closest && e.target.closest('[data-aa-rec-colorsel]'); if (!cs) return;
      var card = cs.closest('.aa-rec'), dot = card && [].filter.call(card.querySelectorAll('[data-aa-rec-dot]'), function (x) { return x.getAttribute('data-value') === cs.value; })[0];
      if (dot) pickColor(dot);
    });
    // color dot on a suggestion: rebuild its size chips for that color and swap the photo
    function pickColor(dot) {
      var card = dot.closest('.aa-rec'), json = card && card.querySelector('[data-aa-rec-variants]'); if (!json) return;
      var vs; try { vs = JSON.parse(json.textContent); } catch (err) { return; }
      var col = dot.getAttribute('data-value'), title = (card.querySelector('.aa-rec__title') || {}).textContent || '';
      [].forEach.call(card.querySelectorAll('[data-aa-rec-dot]'), function (x) { x.setAttribute('aria-pressed', x === dot ? 'true' : 'false'); });
      var csel = card.querySelector('[data-aa-rec-colorsel]'); if (csel && csel.value !== col) csel.value = col;
      var sel = card.querySelector('[data-aa-rec-size]');
      if (sel) {
        var was = sel.selectedIndex > 0 ? sel.options[sel.selectedIndex].getAttribute('data-size') : '';
        sel.innerHTML = '<option value="">size</option>';
        vs.forEach(function (v) {
          if (v[1] !== col) return;
          var o = document.createElement('option');
          o.value = v[0]; o.setAttribute('data-size', v[2]);
          o.textContent = String(v[2]).toLowerCase() + (v[3] ? '' : ' (sold out)');
          if (!v[3]) o.disabled = true;
          if (v[3] && v[2] === was) o.selected = true; // keep the size they'd already picked
          sel.appendChild(o);
        });
      }
      var img = card.querySelector('.aa-rec__media img'), pic = vs.filter(function (v) { return v[1] === col && v[4]; })[0];
      if (img && pic) { img.removeAttribute('srcset'); img.src = pic[4]; }
      syncPrice(card);
    }
    d.addEventListener('click', function (e) {
      var dot = e.target.closest('[data-aa-rec-dot]'); if (dot) { pickColor(dot); return; }
      var more = e.target.closest('[data-aa-rec-more]'); if (more) { var g = more.parentNode; g.classList.remove('is-collapsed'); more.remove(); var nx = g.querySelector('[data-aa-rec-dot]:nth-child(6)'); if (nx) nx.focus(); return; }
      var nav = e.target.closest('[data-aa-recs-nav]');
      if (nav) { var r = nav.parentNode.querySelector('.aa-recs__row'); if (r) r.scrollBy({ left: r.clientWidth * parseInt(nav.getAttribute('data-aa-recs-nav'), 10), behavior: 'smooth' }); return; }
      var b = e.target.closest('[data-aa-rec-add]'); if (!b || b.disabled) return;
      var vid = b.getAttribute('data-variant-id');
      // round + buttons (.aa-rec__buy) show state with classes; their only text is the visually hidden label
      var round = !!b.closest('.aa-rec__buy');
      var say = function (txt) { var lbl = round && b.querySelector('span'); if (lbl) lbl.textContent = txt; else b.textContent = txt; };
      if (!vid) {
        var sel = b.parentNode.querySelector('[data-aa-rec-size]');
        vid = sel && sel.value;
        if (!vid) { // size not chosen yet
          if (round) { // the round + is too small for words: point at the size select instead
            if (sel) { sel.classList.add('is-need'); sel.focus(); setTimeout(function () { sel.classList.remove('is-need'); }, 1600); }
            return;
          }
          var t0 = b.innerHTML; b.textContent = 'pick size';
          if (sel) sel.focus();
          setTimeout(function () { b.innerHTML = t0; }, 1600); return;
        }
      }
      var chip = b.classList.contains('aa-rec__chip');
      var row = chip ? b.parentNode : null;
      if (row) row.classList.add('is-busy'); // one add at a time; siblings stay readable (no sold-out styling)
      var t = b.innerHTML; if (chip) b.classList.add('is-adding'); else { b.disabled = true; say('adding'); if (round) b.classList.add('is-adding'); }
      fetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 }) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) { if (chip) { b.classList.remove('is-adding'); b.disabled = true; if (row) row.classList.remove('is-busy'); } else { say('sold out'); b.classList.remove('is-adding'); } return; }
          if (chip || round) { b.classList.remove('is-adding'); b.classList.add('is-added'); } if (!chip) say('added');
          if (page) { setTimeout(function () { location.reload(); }, 350); return; }
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        }).catch(function () { b.disabled = false; b.innerHTML = t; b.classList.remove('is-adding'); if (row) row.classList.remove('is-busy'); });
    });
    // Phone swipe for the "one more design" row (Oct 21, Mike: hard to drag without hitting the colour/size pickers).
    // A sideways drag that starts anywhere on the row (pickers included) scrolls it and settles on the nearest card; a
    // plain tap still opens the picker or presses the button; vertical drags keep scrolling the drawer.
    var drag = null, eatClick = false;
    d.addEventListener('touchstart', function (e) {
      var row = e.target.closest && e.target.closest('.aa-recs__row'); if (!row || e.touches.length !== 1) { drag = null; return; }
      drag = { row: row, x: e.touches[0].clientX, y: e.touches[0].clientY, left: row.scrollLeft, on: false, t: Date.now() };
    }, { passive: true });
    d.addEventListener('touchmove', function (e) {
      if (!drag) return;
      var dx = e.touches[0].clientX - drag.x, dy = e.touches[0].clientY - drag.y;
      if (!drag.on) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        if (Math.abs(dy) > Math.abs(dx)) { drag = null; return; }      // vertical: leave it to the drawer
        drag.on = true; drag.row.style.scrollSnapType = 'none'; drag.row.style.scrollBehavior = 'auto';
        if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
      }
      e.preventDefault(); drag.row.scrollLeft = drag.left - dx; drag.vx = dx / Math.max(Date.now() - drag.t, 1);
    }, { passive: false });
    d.addEventListener('touchend', function (e) {
      if (!drag || !drag.on) { drag = null; return; }
      var row = drag.row, card = row.querySelector('.aa-rec'), step = card ? card.getBoundingClientRect().width + 12 : row.clientWidth / 2;
      var fling = (drag.vx || 0) < -0.3 ? 1 : (drag.vx || 0) > 0.3 ? -1 : 0;
      var target = Math.max(0, Math.round(row.scrollLeft / step + fling * 0.5) * step);
      row.scrollTo({ left: target, behavior: 'smooth' });
      setTimeout(function () { row.style.scrollSnapType = ''; row.style.scrollBehavior = ''; }, 450);
      eatClick = true; setTimeout(function () { eatClick = false; }, 350); drag = null;
      if (e.cancelable) e.preventDefault();                               // no tap on the picker the drag ended on
    }, { passive: false });
    d.addEventListener('click', function (e) { if (eatClick && e.target.closest && e.target.closest('.aa-recs__row')) { e.preventDefault(); e.stopPropagation(); } }, true);
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
